import absoluteMonthlyRecurrence from 'owa-service/lib/factory/absoluteMonthlyRecurrence';
import createRecurrenceRange from './createRecurrenceRange';
import recurrenceType from 'owa-service/lib/factory/recurrenceType';
import RecurrenceType from 'owa-service/lib/contract/RecurrenceType';
import { getDate, DisplayDate } from 'owa-datetime';

export default function createAbsoluteMonthlyRecurrence(
    startDate: DisplayDate,
    interval: number,
    endDate: DisplayDate
): RecurrenceType {
    let day = getDate(startDate);

    let recurrencePattern = absoluteMonthlyRecurrence({
        DayOfMonth: day,
        Interval: interval,
    });

    let recurrenceRange = createRecurrenceRange(startDate, endDate);

    return recurrenceType({
        RecurrencePattern: recurrencePattern,
        RecurrenceRange: recurrenceRange,
    });
}
